export const productDefaultValues = {};
